export default __webpack_public_path__ + "static/media/EP15_ERYTHREE.3f86105d.mp3";